import { createMulticastServiceType } from '@tv2-player/service-container/src/serviceContainer';
import { IDatadogLogger } from './IDatadogLogger';

export const DatadogLoggerService = createMulticastServiceType<IDatadogLogger>();
